<template>
  <div class="bg-imgcolor">
    <vx-card class="card-tem bg-imgcolor2">
      <!-- <div class="card-tem"> -->
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
          <div tag="div" class="vx-logo mx-auto flex items-center mb-4">
            <!-- <logo class="wlogo mr-4 fill-current text-primary" /> -->
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="8"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-input
            class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
            placeholder="BUSCAR EMPRESA"
            v-model="searchText"
            @input="searchCompany()"
            size="large"
          />
        </vs-col>
      </vs-row>
      <!-- </div> -->
    </vx-card>
    <!-- <vx-card> -->
    <div>
      <div class="button-container">
        <!-- <vs-button class="button-css" @click="searchClass('')">TODOS
                    
                </vs-button> -->
        <div @click="searchClass('')" class="category">
          <i class="fa fa-search iconbutton"></i>
          <div class="name">TODOS</div>
        </div>
        <div
          @click="searchClass(clase.codclaec)"
          class="category"
          v-for="clase in clases"
          :key="clase.codclaec"
        >
          <i :class="(clase.icoclaec || 'fa fa-info') + ' iconbutton'"></i>
          <div class="name">{{ clase.nomclaec }}</div>
        </div>
      </div>
    </div>
    <!-- </vx-card> -->
    <div
      class="h-screen flex w-full bg-imgcolor vx-row no-gutter justify-center "
    >
      <div>
        <vs-divider
          position="center"
          color="rgb(255, 255, 255, 0)"
        ></vs-divider>

        <ais-instant-search
          :search-client="searchClient"
          index-name="instant_search"
          id="algolia-instant-search-demo"
        >
          <!-- SEARCH RESULT -->
          <ais-hits>
            <div slot-scope="{ items }">
              <!-- GRID VIEW -->
              <template>
                <div
                  class="contentBack items-grid-view vx-row match-height itemspadding"
                >
                  <div
                    class="vx-col lg:w-1/3 sm:w-2/2 w-full itemcompany"
                    v-for="item in empresas"
                    :key="item.codcli"
                  >
                    <item-grid-view :item="item"> </item-grid-view>
                  </div>
                </div>
              </template>
            </div>
          </ais-hits>
        </ais-instant-search>

        <!-- </vx-card> -->
      </div>
    </div>
  </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
import {
  AisClearRefinements,
  AisConfigure,
  AisHierarchicalMenu,
  AisHits,
  AisInstantSearch,
  AisNumericMenu,
  AisPagination,
  AisRangeInput,
  AisRatingMenu,
  AisRefinementList,
  AisSearchBox,
  AisSortBy,
  AisStats,
} from "vue-instantsearch";
import algoliasearch from "algoliasearch/lite";
import axios from "axios";
import auth from "@/auth/authService";
import Vue from "vue";
import { mapMutations, mapState, mapActions } from "vuex";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import Logo from "@/layouts/components/LogoFull.vue";

export default {
  data() {
    return {
      searchClient: algoliasearch(
        "latency",
        "6be0576ff61c053d5f9a3225e2a90f76"
      ),
      value1: "",
      searchText: "",
      currentItemView: "item-grid-view",
      empresas: [],
      clases: [],
      clasesname: [],
      class: "",
    };
  },
  components: {
    countdown: VueCountdown,
    ItemGridView: () =>
      import("../webEcommerce/pedidos/components/ItemGridViewCompany"),
    ItemListView: () =>
      import("../webEcommerce/pedidos/components/ItemListView"),
    AisClearRefinements,
    AisConfigure,
    AisHierarchicalMenu,
    AisHits,
    AisInstantSearch,
    AisNumericMenu,
    AisPagination,
    AisRangeInput,
    AisRatingMenu,
    AisRefinementList,
    AisSearchBox,
    AisSortBy,
    AisStats,
    Logo,
  },
  methods: {
    loadClases: function() {
      axios
        .post("http://movil.microplussql.com:3300/api/v1/claeco")
        .then((response) => {
          var c = response.data.data;
          if (c) {
            c.sort(function(a, b) {
              if (a.nomclaec > b.nomclaec) {
                return 1;
              }
              if (a.nomclaec < b.nomclaec) {
                return -1;
              }
              return 0;
            });
          }
          this.clases = c;
          this.clasesname = response.data.data;
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Server Attempt",
            text: "No se pudo conectar al servidor",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
    },
    loadRegistradas: function(payload) {
      axios
        .post("http://movil.microplussql.com:3300/api/v1/empeco", {
          search: payload.search,
          clases: payload.clases,
        })
        .then((response) => {
          this.empresas = response.data.data;
          for (const key in response.data.data) {
            if (response.data.data[key].clases)
              response.data.data[key].clases = response.data.data[
                key
              ].clases.split(",");
            for (const aux in response.data.data[key].clases) {
              for (const aux2 in this.clasesname) {
                if (
                  response.data.data[key].clases[aux] ==
                  this.clasesname[aux2].codclaec
                ) {
                  response.data.data[key].clases[aux] = this.clasesname[
                    aux2
                  ].nomclaec;
                }
              }
            }
          }
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Server Attempt",
            text: "No se pudo conectar al servidor",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
    },
    searchCompany() {
      var payloadCompany = [];
      payloadCompany.search = this.searchText || "";
      payloadCompany.clases = this.class || "";
      this.loadRegistradas(payloadCompany);
    },
    searchClass(clase) {
      var payloadCompany = [];
      payloadCompany.search = this.searchText || "";
      payloadCompany.clases = clase || "";
      this.loadRegistradas(payloadCompany);
    },
  },
  created() {
    this.loadClases();
    var payloadCompany = [];
    payloadCompany.search = "";
    payloadCompany.clases = "";
    this.loadRegistradas(payloadCompany);
  },
  mounted() {
    //    this.add()
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/search.scss";
.itemspadding {
  padding-left: 50px;
  padding-right: 50px;
  justify-content: center;
}
.button-icon {
  width: min-content;
}
.button-container {
  display: flex;
  justify-content: space-between;
  //   flex-wrap: wrap;
  overflow-x: auto;
  overflow-y: hidden;
  //   background-color: white;
  align-items: center;
  background-color: aliceblue;
  border-radius: 100px;
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 20px;
}
.button-css {
  margin: 1rem;
  min-width: fit-content;
}
.itemcompany {
  min-width: 400px;
}
.category {
  transition: 300ms;
  flex-direction: column;
  cursor: pointer;
  opacity: 1;
  margin: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.category:hover {
  opacity: 0.8;
  transform: scale(1.1);
}
.svg-inline--fa {
  width: 1em;
  color: white;
  font-size: 1.8rem;
}
.iconbutton {
  color: white !important;
  width: 50px !important;
  height: 50px;
  min-width: 50px;
  border-radius: 50%;
  background-color: #306896;
  padding: 12px;
}
.name {
  color: gray;
  inline-size: max-content;
}
.bg-imgcolor {
  background-color: #306896;
}
.bg-imgcolor2 {
  background: linear-gradient(to top right, #33ccff 3%, #009999 95%);
}
.wlogo {
  width: 90%;
}
.contentBack {
  background-color: #306896;
}
@media (max-width: 600px) {
  .itemcompany {
    min-width: auto;
    width: 100%;
    // background-color: black;
  }
  .button-css {
    margin: 0.5rem;
    min-width: auto;
    width: 100%;
  }
}
</style>
